var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.1325 35.6326C31.7849 38.1843 27.7087 39.5979 23.5 39.6667C9.79165 39.6667 1.95831 24.0001 1.95831 24.0001C4.39426 19.4604 7.77287 15.4942 11.8675 12.3676M19.3875 8.80339C20.7355 8.48786 22.1156 8.33014 23.5 8.33339C37.2083 8.33339 45.0416 24.0001 45.0416 24.0001C43.8529 26.224 42.4352 28.3177 40.8116 30.2471M27.6516 28.1517C27.1138 28.7289 26.4652 29.1919 25.7445 29.513C25.0239 29.8341 24.2459 30.0068 23.4571 30.0207C22.6682 30.0346 21.8847 29.8895 21.1531 29.594C20.4216 29.2985 19.7571 28.8587 19.1992 28.3009C18.6413 27.743 18.2015 27.0784 17.906 26.3469C17.6105 25.6154 17.4654 24.8318 17.4793 24.043C17.4933 23.2541 17.6659 22.4762 17.987 21.7555C18.3081 21.0348 18.7711 20.3862 19.3483 19.8484",
    stroke: "#929292",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.95831 2.45834L45.0416 45.5417",
    stroke: "#929292",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVisible);
export default __webpack_public_path__ + "static/media/no-visible.026a6054474669c8c583f45c0c9f189e.svg";
export { ForwardRef as ReactComponent };